/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { classNames } from '@ember-decorators/component';
import { sortBy } from '@linc-technologies/linced-common/utils/arrays';

@classNames('profile-banner')
export default class ProfileBanner extends Component {
  // Component versioning
  @tracked visualStyle = 'v1';

  @service
  store;

  maxBadges = 10;
  @tracked
  selectedBadge = null;
  @tracked
  badgeDialogOpen = false;
  @tracked
  showAllBadges = false;
  @tracked
  loadingGoalsForBadges = false;
  loadedSubjects = [];

  @computed('badges.[]')
  get displayBadges() {
    return this.allBadgesSorted.slice(0, this.maxBadges);
  }

  @computed('badges.[]')
  get allBadgesSorted() {
    return sortBy(this.badges, 'createTime').reverse();
  }

  @computed('badges.[]')
  get showMore() {
    return this.badges.length > this.maxBadges;
  }

  @action
  openBadgeDialog(badge) {
    this.selectedBadge = badge;
    this.showAllBadges = false;
    this.badgeDialogOpen = true;
    let subjectId = badge.get('subject_id');
    if (!this.loadedSubjects.includes(subjectId)) {
      this.loadingGoalsForBadges = true;
      // Load all goals for this badge into the store
      // We don't need to do anything with them specifically
      this.store.query('goals/goal', { subjectId }).then(() => {
        this.loadedSubjects.push(subjectId);
        this.loadingGoalsForBadges = false;
      });
    }
  }

  @action
  closeBadgeDialog() {
    this.badgeDialogOpen = false;
    this.selectedBadge = null;
  }
}
